(function () {
  'use strict';
  if (window.BCJSalePrice) return;
  var selector = '[data-bcj-sale-price]';
  var initialized = new WeakSet();
  var queue = new Set();
  var frame = 0;
  function cents(value) {
    if (value == null || String(value).trim() === '') return null;
    var result = Number(value);
    return Number.isFinite(result) && result >= 0 ? Math.round(result) : null;
  }
  function currency(node, amount) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: node.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(amount / 100); }
    catch (_) { return (amount / 100).toFixed(2); }
  }
  function exactPercent(reference, current, quantity) {
    if (!(reference > current && current >= 0)) return 0;
    var percent = Math.round((reference - current) * 100 / reference);
    quantity = Number.isSafeInteger(quantity) && quantity > 0 ? quantity : 1;
    var expected = Math.round(reference * (100 - percent) / 100);
    var perUnit = reference % quantity === 0 && current % quantity === 0 &&
      Math.round(reference / quantity * (100 - percent) / 100) * quantity === current;
    return expected === current || perUnit ? percent : 0;
  }
  function packReference(node, current) {
    if (!node.dataset.packPrices || node.dataset.packProductHandle !== node.dataset.productHandle) return null;
    try {
      var entry = JSON.parse(node.dataset.packPrices)[node.dataset.variantId];
      var quantity = Number(node.dataset.pricingQuantity || 1);
      if (!entry || !Number.isSafeInteger(quantity) || quantity < 1) return null;
      var base = entry.base * quantity, reference = entry.reference * quantity;
      if (!Number.isSafeInteger(base) || !Number.isSafeInteger(reference)) return null;
      return !node.dataset.sellingPlanId && current < base ? base : reference;
    } catch (_) { return null; }
  }
  function details(base, current, comparison, quantity) {
    base = cents(base); current = cents(current); comparison = cents(comparison);
    if (base == null || current == null) return null;
    var reference = comparison > base ? comparison : current < base ? base : 0;
    if (reference <= current) reference = 0;
    return { price: current, reference: reference, percent: exactPercent(reference, current, quantity) };
  }
  function textNode(tag, attribute, className, value) {
    var node = document.createElement(tag);
    node.setAttribute(attribute, ''); node.className = className; node.textContent = value;
    return node;
  }
  function paint(node, result) {
    if (!result) return;
    var render = node.querySelector('[data-bcj-sale-render]');
    if (!render) { render = document.createElement('span'); render.setAttribute('data-bcj-sale-render', ''); node.appendChild(render); }
    render.classList.add('bcj-sale-price__render');
    // Rounded wording is limited to Zesty's authorized USD price ratio.
    // Comparing ratios also covers cart line totals for multiple bundles.
    var roundedZesty = node.dataset.productHandle === 'zesty-halloween' && node.dataset.currency === 'USD'
      && result.reference > 0 && result.price * 9900 === result.reference * 5999;
    var badgeText = roundedZesty ? '40% OFF' : result.percent > 0 ? result.percent + '% OFF' : 'Save ' + currency(node, result.reference - result.price);
    var signature = [result.price, result.reference, result.percent, badgeText, node.dataset.priceFrom, node.dataset.currency].join(':');
    // Abra can redraw the children without changing the resolved cents.
    var currentNode = render.querySelector('[data-bcj-sale-current]');
    var referenceNode = render.querySelector('[data-bcj-sale-ref]');
    var badgeNode = render.querySelector('[data-bcj-sale-percent]');
    var fromNode = render.querySelector('[data-bcj-sale-from]');
    var complete = currentNode && currentNode.textContent === currency(node, result.price) && !currentNode.hidden
      && (result.reference ? referenceNode && referenceNode.textContent === currency(node, result.reference) && !referenceNode.hidden : !referenceNode)
      && (result.reference > 0 ? badgeNode && badgeNode.textContent === badgeText && !badgeNode.hidden : !badgeNode)
      && (node.dataset.priceFrom === 'true' ? fromNode && fromNode.textContent === 'From' : !fromNode);
    if (render.dataset.bcjPainted !== signature || !complete) {
      var children = [];
      if (node.dataset.priceFrom === 'true') children.push(textNode('span', 'data-bcj-sale-from', '', 'From'));
      if (result.reference) {
        var reference = textNode('s', 'data-bcj-sale-ref', 'bcj-sale-price__reference', currency(node, result.reference));
        reference.setAttribute('aria-label', 'Regular price ' + reference.textContent); children.push(reference);
      }
      var current = textNode('strong', 'data-bcj-sale-current', 'bcj-sale-price__current', currency(node, result.price));
      current.setAttribute('aria-label', 'Current price ' + current.textContent); children.push(current);
      if (result.reference > 0) children.push(textNode('span', 'data-bcj-sale-percent', 'bcj-sale-price__badge', badgeText));
      render.replaceChildren.apply(render, children);
      render.dataset.bcjPainted = signature;
    }
    var resultKey = [result.price, result.reference, result.percent].join(':');
    if (node.dataset.bcjResolved !== resultKey) {
      node.dataset.bcjResolved = resultKey;
      node.dispatchEvent(new CustomEvent('bcj:sale-price:change', { bubbles: true, detail: result }));
    }
  }
  function normalize(node) {
    var render = node.querySelector('[data-bcj-sale-render]');
    if (!render) return;
    var current = cents(render.dataset.bcjFinalCents);
    var base = cents(render.dataset.bcjOriginalCents);
    var compare = cents(render.dataset.bcjCompareCents);
    if (current == null || base == null) return;
    // The vendor has already resolved eligibility, rounding and the selling plan.
    var packCompare = packReference(node, current);
    if (packCompare !== null) compare = packCompare;
    paint(node, details(base, current, compare, Number(node.dataset.pricingQuantity || 1)));
  }
  function flush() {
    frame = 0;
    queue.forEach(function (node) { if (node.isConnected) normalize(node); }); queue.clear();
  }
  function schedule(node) { queue.add(node); if (!frame) frame = requestAnimationFrame(flush); }
  function initialize(node) {
    if (initialized.has(node)) return;
    initialized.add(node);
    var observer = new MutationObserver(function () { schedule(node); });
    observer.observe(node, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-bcj-final-cents', 'data-bcj-original-cents', 'data-bcj-compare-cents'] });
    normalize(node);
  }
  function init(root) {
    if (root.matches && root.matches(selector)) initialize(root);
    root.querySelectorAll(selector).forEach(initialize);
  }
  var refreshPending = false;
  function refresh() {
    if (refreshPending) return;
    refreshPending = true;
    requestAnimationFrame(function () { refreshPending = false; init(document); window.dispatchEvent(new Event('bcj:sale-price:refresh')); });
  }
  function update(node, values) {
    if (!node) return;
    if (!node.matches(selector)) node = node.querySelector(selector);
    if (!node) return;
    values = values || {};
    var map = { price: 'priceCents', compareAt: 'compareAtCents', currentPrice: 'currentPriceCents', handle: 'productHandle', variantId: 'variantId', sellingPlanId: 'sellingPlanId', from: 'priceFrom' };
    Object.keys(map).forEach(function (key) { if (Object.prototype.hasOwnProperty.call(values, key)) node.dataset[map[key]] = String(values[key] == null ? '' : values[key]); });
    if (!Object.prototype.hasOwnProperty.call(values, 'currentPrice') && Object.prototype.hasOwnProperty.call(values, 'price')) node.dataset.currentPriceCents = node.dataset.priceCents;
    var render = node.querySelector('[data-bcj-sale-render]');
    if (!render) { render = document.createElement('span'); render.setAttribute('data-bcj-sale-render', ''); node.appendChild(render); }
    render.dataset.bcjFinalCents = node.dataset.currentPriceCents || node.dataset.priceCents;
    render.dataset.bcjOriginalCents = node.dataset.priceCents;
    render.dataset.bcjCompareCents = node.dataset.compareAtCents || '0';
    initialize(node); normalize(node); refresh();
  }
  window.BCJSalePrice = { init: init, update: update, details: details, exactPercent: exactPercent, packReference: packReference, refresh: refresh };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); refresh(); });
  document.addEventListener('quickview:loaded', function () { init(document); refresh(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
